import { render, staticRenderFns } from "./Rulement.vue?vue&type=template&id=320ee616&scoped=true&"
import script from "./Rulement.vue?vue&type=script&lang=js&"
export * from "./Rulement.vue?vue&type=script&lang=js&"
import style0 from "./Rulement.vue?vue&type=style&index=0&id=320ee616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320ee616",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
